<template>
  <div class="roster-report-list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" class="mt-2" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('side_bar.roster_report') }}</strong>
            </div>
            <b-row>
              <b-col cols="3" lg="3">
                <b-card :no-body="true">
                  <b-card-body class="p-0 clearfix">
                    <i class="fa fa-bar-chart bg-primary p-4 px-5 font-2xl mr-3 float-left"></i>
                    <div class="h5 text-primary mb-0 pt-3">{{number_of_order}}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">{{$t('report.number_of_order')}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="3" lg="3">
                <b-card :no-body="true">
                  <b-card-body class="p-0 clearfix">
                    <i class="fa fa-bar-chart bg-primary p-4 px-5 font-2xl mr-3 float-left"></i>
                    <div class="h5 text-primary mb-0 pt-3">{{number_of_pending_order}}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">{{$t('report.number_of_pending_order')}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="3" lg="3">
                <b-card :no-body="true">
                  <b-card-body class="p-0 clearfix">
                    <i class="fa fa-bar-chart bg-primary p-4 px-5 font-2xl mr-3 float-left"></i>
                    <div class="h5 text-primary mb-0 pt-3">{{number_of_late_order}}</div>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">{{$t('report.number_of_late_order')}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="3" lg="3">
                <div class="pull-right mr-4">
                  <b-input-group class="pt-2">
                    <b-form-select v-model="user_uuid" :options="users">
                    </b-form-select>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <button type="button" @click="activeFromRoster" class="btn bg-main"><i class="fa fa-check" ></i> {{$t('common.active')}}</button>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </div>
                <div class="pull-right mr-4">
                  <div class="input-group-append">
                    <b-input-group class="pt-2">
                      <button type="button" class="btn" :class="{'bg-main': !intervalLoadOrder}" @click="setIntetvalLoadOrder">
                        <span v-if="!intervalLoadOrder"><i class="fa fa-filter"></i> {{$t('common.auto_refresh')}}</span>
                        <span v-else><i class="fa fa-filter"></i> {{$t('common.stop_auto')}}</span>
                      </button>
                    </b-input-group>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-col cols="12" class="text-center">
              <b-row>
                <div class="table-responsive">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>
                          #
                        </th>
                        <th scope="col" v-for="item in dataTable.fields" :key="item.id">
                          <span v-if="item.label != null">{{$t('report.'+item.label)}}</span>
                          <span v-if="item.label == null">{{$t('report.'+item.name)}}</span>
                        </th>
                        <th>{{$t('common.action')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="dataTable.items.length == 0">
                        <td class="text-center" :colspan="dataTable.fields.length + 2">
                          {{$t('message.no_data')}}
                        </td>
                      </tr>
                      <tr v-for="(item,index) in dataTable.items" :key="index+0">
                        <td>{{index + 1}}</td>
                        <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                          <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                          <span v-else>{{item[field.name]}}</span>
                        </td>
                        <td>
                          <b-button size="sm" variant="danger" v-on:click="removeFromRoster(item.uuid)">
                            <i class="fa fa-times"></i> {{$t('common.remove')}}
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
              <b-row>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
              </b-row>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import DataTable from '../../../components/Partials/DataTable'

export default {
  name: 'RosterReportList',
  components: {
    DataTable
  },
  data: function () {
    return {
      intervalLoadOrder: null,
      users: [],
      user_uuid: '',
      number_of_order: 0,
      number_of_pending_order: 0,
      number_of_late_order: 0,
      dataTable: {
        items: [],
        fields: [
          {
            name: 'username',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              return data
            }
          },
          {
            name: 'number_of_order',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              return data
            }
          },
          {
            name: 'number_of_pending_order',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              return data
            }
          },
          {
            name: 'number_of_late_order',
            filter: true,
            sort: true,
            render: (data, row) => {
              if (data == null) {
                return ''
              }

              return data
            }
          }
        ],
        sort: {
          field: 'number_of_order',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 10,
        source: null
      }
    }
  },
  methods: {
    setIntetvalLoadOrder () {
      let vm = this
      if (!vm.intervalLoadOrder) {
        vm.intervalLoadOrder = setInterval(function () {
          vm.refreshData()
        }, 10000)
        return false
      } else {
        clearInterval(this.intervalLoadOrder)
        vm.intervalLoadOrder = null
      }
    },
    refreshData () {
      let vm = this
      vm.listNotReadyUsers()
      vm.listUserOrderStatus()
    },
    listNotReadyUsers () {
      let vm = this
      vm.axios.report.getNotReadyUser(function (response) {
        let data = response.data.data
        if (data) {
          vm.users = []
          for (let i in data) {
            vm.users.push({
              text: data[i].name,
              value: data[i].uuid
            })
          }
        }
      })
    },
    listUserOrderStatus () {
      let vm = this
      vm.axios.report.getUserOrderReport(function (response) {
        let data = response.data.data
        if (data) {
          vm.dataTable.items = data
          vm.number_of_order = 0
          vm.number_of_pending_order = 0
          vm.number_of_late_order = 0
          for (let i in vm.dataTable.items) {
            vm.number_of_order += vm.dataTable.items[i].number_of_order
            vm.number_of_pending_order += vm.dataTable.items[i].number_of_pending_order
            vm.number_of_late_order += vm.dataTable.items[i].number_of_late_order
          }
        }
      })
    },
    removeFromRoster (uuid) {
      let vm = this
      this.axios.report.updateReadyForUser({
        uuid: uuid,
        ready: 0
      }, function (response) {
        vm.listUserOrderStatus()
        vm.listNotReadyUsers()
      })
    },
    activeFromRoster () {
      let vm = this
      this.axios.report.updateReadyForUser({
        uuid: vm.user_uuid,
        ready: 1
      }, function (response) {
        vm.listUserOrderStatus()
        vm.listNotReadyUsers()
      })
    }
  },
  created: function () {
    this.listUserOrderStatus()
    this.listNotReadyUsers()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/report/RosterReport.vue